import { defineMessages } from 'react-intl';

export const i18n: {
	noLabelsFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noLabelsFound: {
		id: 'popular-labels-macro.no-labels-found',
		defaultMessage: 'No labels match these criteria.',
		description: 'Message displayed when no popular labels are found.',
	},
	error: {
		id: 'popular-labels-macro.error',
		// oxlint-disable-next-line eslint-core/no-restricted-syntax
		defaultMessage: "We're unable to display the popular labels. Refresh to try again",
		description: 'Generic error message displayed when the popular labels macro fails to render.',
	},
});
